import { createSlice } from "@reduxjs/toolkit";

interface FontSettingsState {
  fontSize: number;
}

const applyFontScaling = (fontSize: number) => {
  const pixelChange = (fontSize - 2) * 2;
  requestAnimationFrame(() => {
    document.documentElement.style.setProperty(
      "--text-scale",
      `${pixelChange}px`
    );
    document.documentElement.style.setProperty("--min-font-size", "8px");
  });
};

const getFontSize = (): number => {
  const saved = localStorage.getItem("fontSize");
  const fontSize = saved ? Number(saved) : 2;
  applyFontScaling(fontSize);
  return fontSize;
};

const initialState: FontSettingsState = {
  fontSize: getFontSize(),
};

export const fontSettingsSlice = createSlice({
  name: "fontSettings",
  initialState,
  reducers: {
    setFontSize: (state, action: { payload: number }) => {
      state.fontSize = action.payload;
      localStorage.setItem("fontSize", action.payload.toString());
      applyFontScaling(action.payload);
    },
  },
});

export const { setFontSize } = fontSettingsSlice.actions;
export default fontSettingsSlice;
